<template>
  <v-card class="page-container balance-details">
  <v-row
    class="d-flex justify-space-between px-4"
    no-gutters
    style="background-color:#F3F5F6;"
    v-if="$vuetify.breakpoint.smAndDown"
  >
    <!-- give the title more room and left-align it -->
    <v-col cols="8" class="d-flex align-center header-title">
      <span class="rewardText text-truncate">{{ $t(`label.account`) }}</span>
    </v-col>

    <v-col cols="4" class="pa-0 d-flex justify-end">
      <v-img :src="`/static/image/icon/Group.png`" height="80px" max-width="100px"></v-img>
    </v-col>
  </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <div class="account-balance-details">
      <v-row
        class="greeting-row mx-4 mb-2"
        no-gutters
        v-if="currentCurrency === 'INR' || currentCurrency === 'NPR'"
      >
        <v-col class="pa-0">
          <div >
            Hi, {{ (memberInfo && (memberInfo.username || memberInfo.memberCode)) || '' }}
          </div>
        </v-col>
      </v-row>

          <v-row class="memberBalance mx-4" no-gutters>
            <v-col class="pa-0 d-flex align-center justify-space-between balance-box ">
              <div class="wallet-left">
                <!--              <img src="/static/svg/wallet.svg" />-->
                <div class="wallet-icon">
                  <img src="/static/svg/wallet.svg" />
                </div>
                <label class="text-capitalize balance" v-if="notLoading">
                  <span v-if="showBalance">{{ memberWallet.totalBalance | currency(currentCurrency) | maskNumber }}</span>
                  <span v-else>{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
                </label>
                <v-progress-circular indeterminate v-if="!notLoading" color="amber" :width="3" :size="24"></v-progress-circular>
              </div>
              <div v-if="notLoading" @click="getMemberWallet()" class="refresh-balance-icon mr-3"></div>
            </v-col>
            <!--          <v-col cols="1"></v-col>-->
            <v-col cols="5" style="text-align: right">
              <!--            <v-btn color="red">{{ $t(`label.voucher`) }}</v-btn>-->
              <v-btn @click="goToVoucher" class="ma-2 white--text voucher-btn" color="newMobileSecondary_2" light>
                <img src="/static/svg/voucher.svg" class="mr-3" />

                {{ $t(`label.voucher`) }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-card class="viptier-details-card" v-if="currentCurrency == 'BDT' || currentCurrency === 'PKR'">
      <v-card-title>
        <span>{{ memberInfo.memberCode }}</span>
        <v-btn :class="`${tierColorThemeName}`">
          <v-img class="ma-tier-icon" :src="`/static/image/viptier/${tierColorThemeName}.png`"></v-img>
          <!--          <img :src="`/static/image/viptier/${tierColorThemeName}.png`" />-->
          <span class="ma-tier-name" :class="`${tierColorThemeName}`">VIP {{ tierName }}</span>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row class="viptier-requirements" no-gutters>
          <v-col cols="6" class="deposit-req pr-4 req-col">
            <p class="mb-2">{{ $t(`label.depositRequirement`) }}</p>
            <p class="pa-0 ma-0 req-figure-p" v-if="this.depoReqRemaining > 0">
              <span class="remain-figure">{{ this.depoReqRemaining.toLocaleString() }}</span>
              {{ $t(`label.remaining`) }}
            </p>
            <p class="pa-0 ma-0" v-else>{{ $t(`label.completed`) }}</p>
            <v-progress-linear :value="currentProgressPercentage" size="20" background-color="grey" color="newMobilePrimary" rounded></v-progress-linear>
          </v-col>
          <v-col cols="6" class="to-req pl-4 req-col">
            <p class="mb-2">{{ $t(`label.turnoverRequirement`) }}</p>
            <p class="pa-0 ma-0 req-figure-p" v-if="this.toReqRemaining > 0">
              <span class="remain-figure">{{ this.toReqRemaining.toLocaleString() }}</span>
              {{ $t(`label.remaining`) }}
            </p>
            <p class="pa-0 ma-0" v-else>{{ $t(`label.completed`) }}</p>
            <v-progress-linear :value="toCurrentProgressPercentage" size="20" background-color="grey" color="newMobilePrimary" rounded></v-progress-linear>
          </v-col>
        </v-row>
      </v-card-text>
      <v-row class="ma-btm-row px-3" no-gutters @click="goToTierDetails">
        <div>
          <span v-if="currentLv >= 3">
            {{
              $t(`label.viptierRefresh`).replace(
                '%s',
                moment()
                  .add(1, 'month')
                  .format('DD/MM/YY')
              )
            }}
          </span>
        </div>

        <div @click="goToTierDetails">
          <span class="seeAll-span">{{ $t(`label.seeAllTiers`) }}</span>

          <v-icon color="newMobileSecondary_2">mdi-chevron-right</v-icon>
        </div>
      </v-row>
    </v-card>

    <!--    <v-row class="mx-4 viptier-details-card">-->
    <!--      <v-col cols="12">-->
    <!--        <v-row class="memberCode-vipTier">-->
    <!--          <v-col class="name">{{ memberInfo.memberCode }}</v-col>-->
    <!--          <v-col class="vip-tier-lvl"></v-col>-->
    <!--        </v-row>-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <!--    old mobile VIP TIER DETAILS-->
    <!--    <v-row no-gutters class="MB-row mx-4 pa-2 viptier-details" :class="`level${currentLv}`" v-if="memberVipTierProgress">-->
    <!--      <v-col>-->
    <!--        <v-row no-gutters>-->
    <!--          <v-col cols="3" class="MB-left-col">-->
    <!--            <v-row class="justify-center align-center">-->
    <!--              <v-avatar tile size="70" class="pr-3">-->
    <!--                <v-img v-if="memberVipTierProgress && memberVipTierProgress.image" :src="`${memberVipTierProgress.image}`"></v-img>-->
    <!--                <v-img v-else :src="`/static/image/viptier/${tierColorThemeName}.png`" eager></v-img>-->
    <!--              </v-avatar>-->
    <!--            </v-row>-->
    <!--          </v-col>-->
    <!--          <v-col cols="9" class="MB-right-col d-flex">-->
    <!--            <v-row no-gutters>-->
    <!--              <span style="text-transform: uppercase;text-align: center">{{ tierName }}</span>-->
    <!--            </v-row>-->
    <!--            <v-row no-gutters>-->
    <!--              <v-progress-linear :value="currentProgressPercentage" size="20" :background-color="`viptier${currentLv}`" color="black"></v-progress-linear>-->
    <!--            </v-row>-->
    <!--            <v-row no-gutters class="progress-details-col">-->
    <!--              <span>{{ $t(`label.lv`) }} {{ currentLv }}</span>-->
    <!--              <span>{{ progressLabel }}</span>-->
    <!--              &lt;!&ndash;              <div v-if="currentLv < 7">&ndash;&gt;-->
    <!--              &lt;!&ndash;                <span v-if="currentProgressPercentage === 100">&ndash;&gt;-->
    <!--              &lt;!&ndash;                  {{ $t(`label.vipTierPendingUpgrade`) }}&ndash;&gt;-->
    <!--              &lt;!&ndash;                </span>&ndash;&gt;-->
    <!--              &lt;!&ndash;                <span v-else>{{ currentDeposit }} / {{ requiredDeposit }}</span>&ndash;&gt;-->
    <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
    <!--              &lt;!&ndash;              <div v-else>&ndash;&gt;-->
    <!--              &lt;!&ndash;                &lt;!&ndash;                highest tier level &ndash;&gt;&ndash;&gt;-->
    <!--              &lt;!&ndash;                <span v-if="currentProgressPercentage === 100">&ndash;&gt;-->
    <!--              &lt;!&ndash;                  {{ $t(`label.vipTierRetentionFulFilled`) }}&ndash;&gt;-->
    <!--              &lt;!&ndash;                </span>&ndash;&gt;-->
    <!--              &lt;!&ndash;                <span v-else>{{ currentDeposit }} / {{ requiredDeposit }}</span>&ndash;&gt;-->
    <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
    <!--              <span v-if="currentLv < 6">{{ $t(`label.lv`) }} {{ nextLv }}</span>-->
    <!--              <span v-else>{{ $t(`label.lv`) }} {{ currentLv }}</span>-->
    <!--            </v-row>-->
    <!--          </v-col>-->
    <!--        </v-row>-->
    <!--        <v-row class="MB-btm-row px-3" no-gutters @click="goToTierDetails">-->
    <!--          <v-col cols="10">-->
    <!--            <span style="font-size: 10px; color: black">-->
    <!--              {{ $t(`label.viewMemberShip`) }}-->
    <!--            </span>-->
    <!--          </v-col>-->
    <!--          <v-spacer></v-spacer>-->
    <!--          <v-icon color="black">mdi-chevron-right</v-icon>-->
    <!--        </v-row>-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <!--    <v-list>-->
    <v-list-item-group v-model="model" multiple class="ma-list-nav">
      <!--parent nav items        -->
      <v-list-item
        v-for="(item, i) in finalNavItems"
        :key="i"
        :to="item.items && item.items.length > 0 ? undefined : {
          name: item.route,
          params: {
            lang: $route.params.lang,
            tab: item.tab ? item.tab : '',
            isExtLink: item.isExtLink ? item.isExtLink : false,
            extURL: item.extURL ? item.extURL : '',
            newPage: item.newPage ? item.newPage : ''
          }
        }"
      >

          <v-list-group
            class="parentNav-list-group"
            :class="finalNavItems.length > i + 1 ? '' : 'no-border'"
            multiple
            :append-icon="item.items && item.items.length > 0 ? 'mdi-chevron-down' : 'mdi-chevron-right'"
          >
          <v-icon width="24" height="24" slot="prependIcon" color="primary" class="parentNav-icon" v-if="item.defaultIcon">{{ `${item.icon}` }}</v-icon>
          <v-icon width="24" height="24" slot="prependIcon" color="primary" class="parentNav-icon">{{ `$${item.icon}` }}</v-icon>
          <template v-slot:activator>
            <v-list-item-content class="parentNav-item-content">
              <v-list-item-title class="parentNav-title">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- children nav items          -->
          <div v-for="child in item.items" :key="child.title" v-if="item.items && item.items.length > 0">
            <!--external routes/links-->
            <v-list-item
              v-if="child.isExtLink"
              class="child-list-item"
              :to="{
                name: child.route,
                params: {
                  lang: $route.params.lang,
                  tab: child.tab ? child.tab : '',
                  isExtLink: child.isExtLink ? child.isExtLink : false,
                  extURL: child.extURL ? child.extURL : '',
                  newPage: child.newPage ? child.newPage : ''
                }
              }"
            >
              <v-list-group class="childNav-list-group" no-action :append-icon="`mdi-chevron-right`">
                <!--                   <v-list-item-title v-text="child.title"></v-list-item-title> -->
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="childNav-title">{{ child.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-group>
            </v-list-item>

            <!--application routes-->
            <v-list-item v-else class="child-list-item" :to="{ name: child.route, params: { lang: $route.params.lang, tab: child.tab } }">
              <v-list-group class="childNav-list-group" no-action :append-icon="`mdi-chevron-right`">
                <!--                   <v-list-item-title v-text="child.title"></v-list-item-title> -->
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="childNav-title">{{ child.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-group>
            </v-list-item>
          </div>
        </v-list-group>

        <!--          <div class="list-group-wrapper">            -->
        <!--          </div>-->
      </v-list-item>
    </v-list-item-group>

    <!--      <v-list-item-group  v-model="item.active" :prepend-icon="item.action" no-action >-->

    <!--        &lt;!&ndash;expansion list&ndash;&gt;-->
    <!--        <v-list-item v-for="child in item.items" :key="child.title" :to="{ name: child.route }">-->
    <!--          <v-list-item-content>-->
    <!--            <v-list-item-title>{{ child.title }}</v-list-item-title>-->
    <!--          </v-list-item-content>-->
    <!--        </v-list-item>-->
    <!--      </v-list-item-group>-->

    <!--      <v-list-group v-for="(item, index) in specialNavItems" :key="item.title" v-model="item.active" :prepend-icon="item.icon">-->
    <!--        <template v-slot:activator>-->
    <!--          <v-list-item-title v-text="item.title"></v-list-item-title>-->
    <!--        </template>-->
    <!--        <v-list-item v-for="child in item.items" :key="child.title" :to="{name:child.route}">-->
    <!--          <v-list-item-title>{{ child.title }}</v-list-item-title>-->
    <!--        </v-list-item>-->
    <!--      </v-list-group>-->
    <!--    </v-list>-->
  </v-card>
</template>

<script>
import { uiHelper, locale } from '@/util'
import AppMemberBalance from '@/components/member/MemberBalance.vue'
import { ROUTE_NAME } from '@/constants/route.constants'
import { SHARED } from '@/constants/constants'
import { MEMBER_VIP_TIER_PROGRESS, MEMBER_WALLET } from '@/store/member.module'
import moment from 'moment'
export default {
  name: 'mobileAccount',
  components: {
    AppMemberBalance
  },
  data: () => ({
    depoReqRemaining: 0,
    toReqRemaining: 0,
    toCurrentProgressPercentage: 0,
    requiredTO: 0,
    currentTO: 0,
    notLoading: true,
    showBalance: true,
    walletBalance: 0,
    progressLabel: '',
    tierBarBgColor: '',
    tierBarColor: '',
    tierColorThemeName: 'newmember',
    tierName: '',
    currentProgressPercentage: 0,
    currentLv: 0,
    nextLv: 0,
    progressRequired: 0,
    currentDeposit: 0,
    requiredDeposit: 0,
    routeName: ROUTE_NAME,
    currentCurrency: uiHelper.getCurrency(),
    currency: SHARED.DEFAULT_CURRENCY,
    specialNavItems: [
      {
        icon: 'mdi-calendar-star',
        title: 'Special 2',
        items: [
          {
            title: 'Refer & Earn',
            route: ROUTE_NAME.REFERRAL_TIER
          }
        ]
      }
    ],
    model: [0, 3],
    finalNavItems: [],
    // navItems: [
    //   {
    //     title: locale.getMessage('label.history'),
    //     active: true,
    //     icon: 'customHistory',
    //     items: [
    //       {
    //         title: locale.getMessage('mobileMenuTitle.betHistory'),
    //         route: ROUTE_NAME.MOBILE_BETTING_HISTORY
    //       },
    //       {
    //         title: locale.getMessage('label.turnoverHistory'),
    //         route: ROUTE_NAME.MOBILE_TO_HISTORY
    //       },
    //       {
    //         title: locale.getMessage('mobileMenuTitle.walletHistory'),
    //         route: ROUTE_NAME.MOBILE_TRANSACTION_HISTORY
    //       }
    //       // {
    //       //   title: 'Promotion History',
    //       //   route: ROUTE_NAME.MOBILE_PROMO_HISTORY
    //       // }
    //       // {
    //       //   title: 'Transactions',
    //       //   route: ROUTE_NAME.MOBILE_ACCOUNT
    //       // }
    //       // {
    //       //   title:'',
    //       //   route:ROUTE_NAME
    //       // }
    //     ]
    //   },
    //   {
    //     icon: 'customSpecial',
    //     title: locale.getMessage('mobileMenuTitle.special'),
    //     items: [
    //       {
    //         title: locale.getMessage('mobileMenuTitle.referral'),
    //         route: ROUTE_NAME.REFERRAL_TIER
    //       },
    //       {
    //         title: locale.getMessage('mobileMenuTitle.bettingPass'),
    //         route: ROUTE_NAME.VIP
    //       },
    //       {
    //         title: locale.getMessage('mobileMenuTitle.agentAffiliate'),
    //         route: uiHelper.getaffLink(),
    //         isExtLink: true
    //       }
    //     ]
    //   },
    //   {
    //     icon: 'customRewards',
    //     title: locale.getMessage('mobileMenuTitle.rewards'),
    //     items: [
    //       {
    //         title: locale.getMessage('label.claimVoucher'),
    //         route: ROUTE_NAME.CLAIM_VOUCHER
    //       },
    //       {
    //         title: locale.getMessage('label.wheelSpin'),
    //         route: ROUTE_NAME.MWOF
    //       },
    //       {
    //         title: locale.getMessage('label.dailyCheckIn'),
    //         route: ROUTE_NAME.REWARDS
    //       }
    //       // {
    //       //   title: locale.getMessage('mobileMenuTitle.rewardStore'),
    //       //   route: ROUTE_NAME.REWARD_STORE_ITEM
    //       // }
    //       // {
    //       //   title: locale.getMessage('label.coinGrab'),
    //       //   route: ROUTE_NAME.GRAB_COIN
    //       // }
    //     ]
    //   },
    //   {
    //     icon: 'customSocial',
    //     title: locale.getMessage('mobileMenuTitle.social'),
    //     items: [
    //       // {
    //       //   title: locale.getMessage('label.liveChat').toUpperCase(),
    //       //   isExtLink: true,
    //       //   route: uiHelper.getLiveChatUrl()
    //       // },
    //       {
    //         title: 'Facebook',
    //         isExtLink: true,
    //         route: uiHelper.getFBLink()
    //       },
    //       {
    //         title: 'Instagram',
    //         isExtLink: true,
    //         route: uiHelper.getInstaLink()
    //       },
    //       {
    //         title: 'Telegram',
    //         isExtLink: true,
    //         route: uiHelper.getTlgLink()
    //       },
    //       {
    //         title: 'Twitter',
    //         isExtLink: true,
    //         route: uiHelper.getTwtLink()
    //       },
    //       {
    //         title: 'YouTube',
    //         isExtLink: true,
    //         route: uiHelper.getYTLink()
    //       }
    //     ]
    //   },
    //   {
    //     icon: 'customSetting',
    //     title: locale.getMessage('mobileMenuTitle.setting'),
    //     items: [
    //       { title: locale.getMessage('label.bankDetail'), route: ROUTE_NAME.BANK_ACCOUNT },
    //       {
    //         title: locale.getMessage('label.profile'),
    //         route: ROUTE_NAME.PERSONAL
    //       },
    //       { title: locale.getMessage('label.changePassword'), route: ROUTE_NAME.CHANGE_PASSWORD }
    //     ]
    //   }
    // ],
    navItemsBDT: [
      {
        title: locale.getMessage('label.profile'),
        icon: 'mdi-account',
        defaultIcon: 'mdi-account',
        route: ROUTE_NAME.PERSONAL
      },
      {
        title: locale.getMessage('label.changePassword'),
        icon: 'mdi-lock',
        defaultIcon: 'mdi-lock',
        route: ROUTE_NAME.CHANGE_PASSWORD
      },
      {
        title: locale.getMessage('label.history'),
        active: true,
        icon: 'customHistory',
        items: [
          {
            title: locale.getMessage('mobileMenuTitle.betHistory'),
            route: ROUTE_NAME.MOBILE_BETTING_HISTORY
          },
          {
            title: locale.getMessage('label.turnoverHistory'),
            route: ROUTE_NAME.MOBILE_TO_HISTORY
          },
          {
            title: locale.getMessage('mobileMenuTitle.walletHistory'),
            route: ROUTE_NAME.MOBILE_TRANSACTION_HISTORY
          }
          // {
          //   title: 'Promotion History',
          //   route: ROUTE_NAME.MOBILE_PROMO_HISTORY
          // }
          // {
          //   title: 'Transactions',
          //   route: ROUTE_NAME.MOBILE_ACCOUNT
          // }
          // {
          //   title:'',
          //   route:ROUTE_NAME
          // }
        ]
      },
      {
        title: locale.getMessage('mobileMenuTitle.agentAffiliate'),
        icon: 'customAgentAffiliate',
        route: ROUTE_NAME.EXTERNAL,
        extURL: uiHelper.getaffLink(),
        newPage: true,
        isExtLink: true
      },
      // {
      //   icon: 'customSpecial',
      //   title: locale.getMessage('mobileMenuTitle.special'),
      //   items: [
      //     {
      //       title: locale.getMessage('mobileMenuTitle.referral'),
      //       route: ROUTE_NAME.REFERRAL_TIER
      //     },
      //     {
      //       title: locale.getMessage('mobileMenuTitle.bettingPass'),
      //       route: ROUTE_NAME.VIP
      //     }
      //   ]
      // },
      // {
      //   icon: 'customRewards',
      //   title: locale.getMessage('mobileMenuTitle.rewards'),
      //   items: [
      //     {
      //       title: locale.getMessage('label.claimVoucher'),
      //       route: ROUTE_NAME.CLAIM_VOUCHER
      //     },
      //     {
      //       title: locale.getMessage('label.wheelSpin'),
      //       route: ROUTE_NAME.MWOF
      //     },
      //     {
      //       title: locale.getMessage('label.dailyCheckIn'),
      //       route: ROUTE_NAME.REWARD_STORE_ITEM,
      //       tab: 'dailyCheckIn'
      //     },
      //     {
      //       title: locale.getMessage('mobileMenuTitle.rewardStore'),
      //       route: ROUTE_NAME.REWARD_STORE_ITEM
      //     }
      //     // {
      //     //   title: locale.getMessage('label.coinGrab'),
      //     //   route: ROUTE_NAME.GRAB_COIN
      //     // }
      //   ]
      // },
      {
        icon: 'customSocial',
        title: locale.getMessage('mobileMenuTitle.social'),
        items: [
          // {
          //   title: locale.getMessage('label.liveChat').toUpperCase(),
          //   isExtLink: true,
          //   route: uiHelper.getLiveChatUrl()
          // },
          {
            title: 'Facebook',
            extURL: uiHelper.getFBLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Instagram',
            extURL: uiHelper.getInstaLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Telegram',
            extURL: uiHelper.getTlgLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Twitter',
            extURL: uiHelper.getTwtLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'YouTube',
            extURL: uiHelper.getYTLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          }
        ]
      },
      {
        title: locale.getMessage('mobileMenuTitle.faq'),
        icon: 'mdi-view-list',
        defaultIcon: 'mdi-view-list',
        route: ROUTE_NAME.FAQ
      }
      // {
      //   icon: 'customSetting',
      //   title: locale.getMessage('mobileMenuTitle.setting'),
      //   items: [
      //     // { title: locale.getMessage('label.bankDetail'), route: ROUTE_NAME.BANK_ACCOUNT },
      //     {
      //       title: locale.getMessage('label.profile'),
      //       route: ROUTE_NAME.PERSONAL
      //     },
      //     { title: locale.getMessage('label.changePassword'), route: ROUTE_NAME.CHANGE_PASSWORD }
      //   ]
      // }
    ],
    navItemsNPR: [
      {
        title: locale.getMessage('label.profile'),
        icon: 'mdi-account',
        defaultIcon: 'mdi-account',
        route: ROUTE_NAME.PERSONAL
      },
      {
        title: locale.getMessage('label.changePassword'),
        icon: 'mdi-lock',
        defaultIcon: 'mdi-lock',
        route: ROUTE_NAME.CHANGE_PASSWORD
      },
      {
        title: locale.getMessage('label.bankDetail'),
        icon: 'mdi-credit-card-multiple',
        defaultIcon: 'mdi-credit-card-multiple',
        route: ROUTE_NAME.BANK_ACCOUNT
      },
      {
        title: locale.getMessage('label.history'),
        active: true,
        icon: 'customHistory',
        items: [
          {
            title: locale.getMessage('mobileMenuTitle.betHistory'),
            route: ROUTE_NAME.MOBILE_BETTING_HISTORY
          },
          {
            title: locale.getMessage('label.turnoverHistory'),
            route: ROUTE_NAME.MOBILE_TO_HISTORY
          },
          {
            title: locale.getMessage('mobileMenuTitle.walletHistory'),
            route: ROUTE_NAME.MOBILE_TRANSACTION_HISTORY
          }
          // {
          //   title: 'Promotion History',
          //   route: ROUTE_NAME.MOBILE_PROMO_HISTORY
          // }
          // {
          //   title: 'Transactions',
          //   route: ROUTE_NAME.MOBILE_ACCOUNT
          // }
          // {
          //   title:'',
          //   route:ROUTE_NAME
          // }
        ]
      },
      {
        title: locale.getMessage('mobileMenuTitle.agentAffiliate'),
        icon: 'customAgentAffiliate',
        route: ROUTE_NAME.EXTERNAL,
        extURL: uiHelper.getaffLink(),
        newPage: true,
        isExtLink: true
      },
      // {
      //   icon: 'customSpecial',
      //   title: locale.getMessage('mobileMenuTitle.special'),
      //   items: [
      //     {
      //       title: locale.getMessage('mobileMenuTitle.referral'),
      //       route: ROUTE_NAME.REFERRAL_TIER
      //     },
      //     {
      //       title: locale.getMessage('mobileMenuTitle.bettingPass'),
      //       route: ROUTE_NAME.VIP
      //     }
      //   ]
      // },
      // {
      //   icon: 'customRewards',
      //   title: locale.getMessage('mobileMenuTitle.rewards'),
      //   items: [
      //     {
      //       title: locale.getMessage('label.claimVoucher'),
      //       route: ROUTE_NAME.CLAIM_VOUCHER
      //     },
      //     {
      //       title: locale.getMessage('label.wheelSpin'),
      //       route: ROUTE_NAME.MWOF
      //     },
      //     {
      //       title: locale.getMessage('label.dailyCheckIn'),
      //       route: ROUTE_NAME.REWARD_STORE_ITEM,
      //       tab: 'dailyCheckIn'
      //     },
      //     {
      //       title: locale.getMessage('mobileMenuTitle.rewardStore'),
      //       route: ROUTE_NAME.REWARD_STORE_ITEM
      //     }
      //     // {
      //     //   title: locale.getMessage('label.coinGrab'),
      //     //   route: ROUTE_NAME.GRAB_COIN
      //     // }
      //   ]
      // },
      {
        icon: 'customSocial',
        title: locale.getMessage('mobileMenuTitle.social'),
        items: [
          // {
          //   title: locale.getMessage('label.liveChat').toUpperCase(),
          //   isExtLink: true,
          //   route: uiHelper.getLiveChatUrl()
          // },
          {
            title: 'Facebook',
            extURL: uiHelper.getFBLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Instagram',
            extURL: uiHelper.getInstaLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Telegram',
            extURL: uiHelper.getTlgLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Twitter',
            extURL: uiHelper.getTwtLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'YouTube',
            extURL: uiHelper.getYTLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          }
        ]
      },
      {
        title: locale.getMessage('mobileMenuTitle.faq'),
        icon: 'mdi-view-list',
        defaultIcon: 'mdi-view-list',
        route: ROUTE_NAME.FAQ
      }
      // {
      //   icon: 'customSetting',
      //   title: locale.getMessage('mobileMenuTitle.setting'),
      //   items: [
      //     // { title: locale.getMessage('label.bankDetail'), route: ROUTE_NAME.BANK_ACCOUNT },
      //     {
      //       title: locale.getMessage('label.profile'),
      //       route: ROUTE_NAME.PERSONAL
      //     },
      //     { title: locale.getMessage('label.changePassword'), route: ROUTE_NAME.CHANGE_PASSWORD }
      //   ]
      // }
    ],
    navItemsINR: [
      {
        title: locale.getMessage('label.profile'),
        icon: 'mdi-account',
        defaultIcon: 'mdi-account',
        route: ROUTE_NAME.PERSONAL
      },
      {
        title: locale.getMessage('label.changePassword'),
        icon: 'mdi-lock',
        defaultIcon: 'mdi-lock',
        route: ROUTE_NAME.CHANGE_PASSWORD
      },
      {
        title: locale.getMessage('label.bankDetail'),
        icon: 'mdi-credit-card-multiple',
        defaultIcon: 'mdi-credit-card-multiple',
        route: ROUTE_NAME.BANK_ACCOUNT
      },
      {
        icon: 'mdi-gift',
        defaultIcon: 'mdi-gift',
        title: locale.getMessage('mobileMenuTitle.rewards'),
        items: [
          {
            title: locale.getMessage('label.wheelSpin'),
            route: ROUTE_NAME.MWOF
          },
          {
            title: locale.getMessage('label.dailyCheckIn'),
            route: ROUTE_NAME.REWARDS
          }
        ]
      },
      {
        title: locale.getMessage('label.history'),
        active: true,
        icon: 'customHistory',
        items: [
          {
            title: locale.getMessage('mobileMenuTitle.betHistory'),
            route: ROUTE_NAME.MOBILE_BETTING_HISTORY
          },
          {
            title: locale.getMessage('label.turnoverHistory'),
            route: ROUTE_NAME.MOBILE_TO_HISTORY
          },
          {
            title: locale.getMessage('mobileMenuTitle.walletHistory'),
            route: ROUTE_NAME.MOBILE_TRANSACTION_HISTORY
          }
          // {
          //   title: 'Promotion History',
          //   route: ROUTE_NAME.MOBILE_PROMO_HISTORY
          // }
          // {
          //   title: 'Transactions',
          //   route: ROUTE_NAME.MOBILE_ACCOUNT
          // }
          // {
          //   title:'',
          //   route:ROUTE_NAME
          // }
        ]
      },
      {
        title: locale.getMessage('mobileMenuTitle.agentAffiliate'),
        icon: 'customAgentAffiliate',
        route: ROUTE_NAME.EXTERNAL,
        extURL: uiHelper.getaffLink(),
        newPage: true,
        isExtLink: true
      },
      // {
      //   icon: 'customSpecial',
      //   title: locale.getMessage('mobileMenuTitle.special'),
      //   items: [
      //     {
      //       title: locale.getMessage('mobileMenuTitle.referral'),
      //       route: ROUTE_NAME.REFERRAL_TIER
      //     },
      //     {
      //       title: locale.getMessage('mobileMenuTitle.bettingPass'),
      //       route: ROUTE_NAME.VIP
      //     }
      //   ]
      // },
      // {
      //   icon: 'customRewards',
      //   title: locale.getMessage('mobileMenuTitle.rewards'),
      //   items: [
      //     {
      //       title: locale.getMessage('label.claimVoucher'),
      //       route: ROUTE_NAME.CLAIM_VOUCHER
      //     },
      //     {
      //       title: locale.getMessage('label.wheelSpin'),
      //       route: ROUTE_NAME.MWOF
      //     },
      //     {
      //       title: locale.getMessage('label.dailyCheckIn'),
      //       route: ROUTE_NAME.REWARD_STORE_ITEM,
      //       tab: 'dailyCheckIn'
      //     },
      //     {
      //       title: locale.getMessage('mobileMenuTitle.rewardStore'),
      //       route: ROUTE_NAME.REWARD_STORE_ITEM
      //     }
      //     // {
      //     //   title: locale.getMessage('label.coinGrab'),
      //     //   route: ROUTE_NAME.GRAB_COIN
      //     // }
      //   ]
      // },
      {
        icon: 'customSocial',
        title: locale.getMessage('mobileMenuTitle.social'),
        items: [
          // {
          //   title: locale.getMessage('label.liveChat').toUpperCase(),
          //   isExtLink: true,
          //   route: uiHelper.getLiveChatUrl()
          // },
          {
            title: 'Facebook',
            extURL: uiHelper.getFBLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Instagram',
            extURL: uiHelper.getInstaLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Telegram',
            extURL: uiHelper.getTlgLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'Twitter',
            extURL: uiHelper.getTwtLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          },
          {
            title: 'YouTube',
            extURL: uiHelper.getYTLink(),
            route: ROUTE_NAME.EXTERNAL,
            newPage: true,
            isExtLink: true
          }
        ]
      },
      {
        title: locale.getMessage('mobileMenuTitle.faq'),
        icon: 'mdi-view-list',
        defaultIcon: 'mdi-view-list',
        route: ROUTE_NAME.FAQ
      }
      // {
      //   icon: 'customSetting',
      //   title: locale.getMessage('mobileMenuTitle.setting'),
      //   items: [
      //     // { title: locale.getMessage('label.bankDetail'), route: ROUTE_NAME.BANK_ACCOUNT },
      //     {
      //       title: locale.getMessage('label.profile'),
      //       route: ROUTE_NAME.PERSONAL
      //     },
      //     { title: locale.getMessage('label.changePassword'), route: ROUTE_NAME.CHANGE_PASSWORD }
      //   ]
      // }
    ]
  }),
  mounted() {
    this.metaTag()
  },
  computed: {
    moment() {
      return moment
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    vipTierUpgrade() {
      return this.$store.state.member.vipTierProgress.upgrade
    },
    vipTierDowngrade() {
      return this.$store.state.member.vipTierProgress.downgrade
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    }
  },
  watch: {
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.getVipTierProgress()
      }
    },
    vipTierUpgrade() {
      // if (Object.keys(this.vipTierUpgrade).length > 0) {
      //   if (this.vipTierUpgrade.current_upgrade_deposit > 0) {
      //     this.currentProgressPercentage = Math.ceil((this.vipTierUpgrade.current_upgrade_deposit / this.vipTierUpgrade.required_upgrade_deposit) * 100)
      //   } else {
      //     this.currentProgressPercentage = 0
      //   }
      //
      //   this.progressRequired = this.vipTierUpgrade.required_upgrade_deposit - this.vipTierUpgrade.current_upgrade_deposit
      // }
    },
    memberVipTierProgress() {
      let vipTierProgress = this.$store.state.member.vipTierProgress
      if (Object.keys(vipTierProgress.pairing).length > 0) {
        let curPairing = vipTierProgress.pairing
        //progress found
        this.showProgress = true
        switch (curPairing.level_sequence) {
          case 1:
            this.tierColorThemeName = 'newmember'
            break
          case 2:
            this.tierColorThemeName = 'bronze'
            break
          case 3:
            this.tierColorThemeName = 'silver'
            break
          case 4:
            this.tierColorThemeName = 'gold'
            break
          case 5:
            this.tierColorThemeName = 'emerald'
            break
          case 6:
            this.tierColorThemeName = 'sapphire'
            break
          case 7:
            this.tierColorThemeName = 'platinum'
            break
          case 8:
            this.tierColorThemeName = 'diamond'
            break
          default:
            this.tierColorThemeName = 'newmember'
            this.tierBarBgColor = '#1867c0'
        }
        this.tierBarBgColor = 'viptier' + this.tierColorThemeName
        this.tierName = curPairing.name
        this.currentLv = this.memberVipTierProgress.level_sequence
        this.nextLv = this.memberVipTierProgress.level_sequence + 1

        this.setVipTierProgressDetails()
      } else {
        //no progress
        this.showProgress = false
      }
    },
    memberWallet() {
      this.notLoading = true
    }
  },
  created() {
    if (this.isLoggedIn) {
      this.getVipTierProgress()
    }

    switch (this.currentCurrency) {
      case 'BDT':
        this.finalNavItems = [...this.navItemsBDT]
        break
      case 'NPR':
        this.finalNavItems = [...this.navItemsNPR]
        break

      case 'INR':
        this.finalNavItems = [...this.navItemsINR]
        break
      default:
        this.finalNavItems = [...this.navItemsBDT]
        break
    }
  },
  methods: {
    getMemberWallet() {
      if (!this.lastDispatchTime || Date.now() - this.lastDispatchTime > 15 * 1000) {
        this.notLoading = false
        this.lastDispatchTime = Date.now() // Update last dispatch time
        this.$store.dispatch(MEMBER_WALLET)
      }
      this.maskBalance()
    },
    maskBalance() {
      this.showBalance = !this.showBalance
    },
    setVipTierProgressDetails() {
      if (this.currentLv < 8) {
        if (this.vipTierUpgrade) {
          if (this.vipTierUpgrade.required_upgrade_deposit && this.vipTierUpgrade.required_upgrade_deposit >= 0) {
            this.requiredDeposit = Number(this.vipTierUpgrade.required_upgrade_deposit)
          }

          if (this.vipTierUpgrade.current_upgrade_deposit && this.vipTierUpgrade.current_upgrade_deposit >= 0) {
            this.currentDeposit = Number(this.vipTierUpgrade.current_upgrade_deposit)
            this.depoReqRemaining = Number(this.requiredDeposit - this.currentDeposit)
          }

          this.progressLabel = this.currentDeposit.toString() + '/' + this.requiredDeposit.toString()

          if (this.vipTierUpgrade.required_upgrade_turnover && this.vipTierUpgrade.required_upgrade_turnover >= 0) {
            this.requiredTO = Number(this.vipTierUpgrade.required_upgrade_turnover)
          }

          if (this.vipTierUpgrade.current_upgrade_turnover && this.vipTierUpgrade.current_upgrade_turnover >= 0) {
            this.currentTO = this.vipTierUpgrade.current_upgrade_turnover
            this.toReqRemaining = Number(this.requiredTO - this.currentTO)
          }
        } else {
          if (this.vipTierUpgrade == null) {
            //pending upgrade tier
            this.progressLabel = locale.getMessage('label.vipTierPendingUpgrade')
          }
        }
      } else {
        //highest tier level in automation = 6 , level 7 is manual upgrade rquired
        //highest level reached = display downgrade progress
        if (this.vipTierDowngrade) {
          if (this.vipTierDowngrade.required_downgrade_deposit && this.vipTierDowngrade.required_downgrade_deposit >= 0) {
            this.requiredDeposit = Number(this.vipTierDowngrade.required_downgrade_deposit)
          }

          if (this.vipTierDowngrade.current_downgrade_deposit && this.vipTierDowngrade.current_downgrade_deposit >= 0) {
            this.currentDeposit = Number(this.vipTierDowngrade.current_downgrade_deposit)
          }
          this.depoReqRemaining = Number(this.requiredDeposit - this.currentDeposit)

          this.progressLabel = this.currentDeposit.toString() + '/' + this.requiredDeposit.toString()

          if (this.vipTierDowngrade.current_downgrade_turnover && this.vipTierDowngrade.required_downgrade_turnover >= 0) {
            this.currentTO = Number(this.vipTierDowngrade.current_downgrade_turnover)
            this.requiredTO = Number(this.vipTierDowngrade.required_downgrade_turnover)
            this.toReqRemaining = Number(this.vipTierDowngrade.required_downgrade_turnover) - Number(this.vipTierDowngrade.current_downgrade_turnover)
          }
        } else {
          //check for whether retention fulfilled
          if (this.vipTierDowngrade == null && this.vipTierUpgrade == null) {
            this.progressLabel = locale.getMessage(`label.vipTierRetentionFulFilled`)
          }
        }
      }

      //cal for progress bar %
      if (this.requiredDeposit > 0) {
        this.currentProgressPercentage = Math.ceil((this.currentDeposit / this.requiredDeposit) * 100)
      } else {
        //assume Denominator = 0 mean no need to upgrade / fulfilled
        //either retention fulfilled or pending upgrade
        this.currentProgressPercentage = 100
      }

      if (this.requiredTO > 0) {
        this.toCurrentProgressPercentage = Math.cell(this.currentTO / this.requiredTO)
      } else {
        this.toCurrentProgressPercentage = 100
      }

      //not using anymore
      //regarding upgrade/downgrade is null or not as long we 100% then display fulfillment message
      if (this.currentProgressPercentage === 100) {
        if (this.currentLv < 8) {
          this.progressLabel = locale.getMessage('label.vipTierPendingUpgrade')
        } else {
          this.progressLabel = locale.getMessage('label.vipTierRetentionFulFilled')
        }
      }
    },
    goToVoucher() {
      this.$router.push({ name: this.routeName.CLAIM_VOUCHER, params: { lang: this.$route.params.lang } })
    },
    goToTierDetails() {
      this.$router.push({ name: this.routeName.VIPTIER, params: { lang: this.$route.params.lang } })
    },
    getVipTierProgress() {
      this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
    },
    metaTag() {
      const currentUrl = window.location.href
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD|en-IN|hi-IN|en-NP|ne-NP|en-PK|ur-PK)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      const Linksenin = `https://${domain}/en-IN${cleanPath}`
      const Linksenhi = `https://${domain}/hi-IN${cleanPath}`
      const Linksenennp = `https://${domain}/en-NP${cleanPath}`
      const Linksennenp = `https://${domain}/ne-NP${cleanPath}`
      const Linksenpk = `https://${domain}/en-PK${cleanPath}`
      const Linksenur = `https://${domain}/ur-PK${cleanPath}`

      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
      uiHelper.setHreflangLinksenin(Linksenin)
      uiHelper.setHreflangLinkshi(Linksenhi)
      uiHelper.setHreflangLinksennp(Linksenennp)
      uiHelper.setHreflangLinksnenp(Linksennenp)
      uiHelper.setHreflangLinksenpk(Linksenpk)
      uiHelper.setHreflangLinksur(Linksenur)
    }
  }
}
</script>

<style lang="scss">
.list-group-wrapper {
  width: 100%;
}

.ma-list-nav {
  background-color: #f3f5f6;
  margin: 8px 16px 16px 16px;
  border-radius: 10px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.account-balance-details {
  //height: 75px;
  padding: 30px 0 0px 0;

  .memberBalance {
    align-items: center;
    justify-content: space-between;
    .balance-box {
      box-shadow: 0px 0px 4px 0px #00000040 inset;
      border-radius: 5px;
      background: white;
      height: 42px;

      .wallet-left {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .wallet-icon {
        background: #ffcc00;
        padding: 6px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .wallet-icon img {
        width: 20px;
        height: 20px;
      }

      .refresh-balance-icon {
        width: 20px;
        height: 20px;
        background-color: #ffce01;
        mask: url(/static/image/profile/icon-refresh-type01.svg);
        mask-repeat: no-repeat;
        mask-position: center;
        -webkit-mask: url(/static/image/profile/icon-refresh-type01.svg);
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-position: center;
        cursor: pointer;
      }
    }

    .voucher-btn.v-btn {
      border-radius: 5px !important;
    }
  }
}

.memberCode-vipTier {
}

.viptier-details-card.v-card {
  margin: 8px 16px 16px 16px;
  border-radius: 10px;

  &.theme--light {
    background-color: #f3f5f6;
  }

  .v-card__title {
    font-size: 1.125rem;
    padding-top: 3%;
    justify-content: space-between;
    .v-btn {
      height: 30px;
      border-radius: 8px;
      padding: 0 10px !important;

      //btn bg color
      &.member {
      }

      &.bronze {
        background-color: rgb(141, 105, 72, 0.5);
      }
      &.silver {
        background-color: rgb(161, 161, 161, 0.5);
      }
      &.diamond {
        background-color: rgb(226, 235, 252, 0.5);
      }
      &.emerald {
        background-color: rgb(131, 211, 154, 0.5);
      }
      &.gold {
        background-color: rgb(203, 190, 101, 0.5);
      }
      &.newmember {
        background-color: rgb(243, 243, 243, 0.5);
      }
      &.platinum {
        background-color: #f5f5f5;
      }
      &.sapphire {
        background-color: rgb(21, 122, 233, 0.5);
      }

      .ma-tier-icon {
        height: 20px;
        width: 20px;
      }

      .ma-tier-name {
        font-weight: bold;

        //text color
        &.bronze {
          color: #4a3726;
        }
        &.silve {
          color: #6b6b6b;
        }
        &.diamond {
          color: #70757d;
        }
        &.emerald {
          color: #38573f;
        }
        &.gold {
          color: #756e3a;
        }
        &.newmember {
          color: #707070;
        }
        &.platinum {
          color: #4f4a4d;
        }
        &.sapphire {
          color: #0c4482;
        }
      }
    }
  }

  .v-card__text {
    .deposit-req {
      border-right: 1px solid #9c9898;
    }

    .to-req {
      padding-left: 16px;
    }

    .req-figure-p {
    }

    .remain-figure {
      font-size: 1.1rem;
    }

    .req-col {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  .ma-btm-row {
    justify-content: space-between;
    span {
      font-size: 0.71rem;

      &.seeAll-span {
        color: var(--v-newMobileSecondary_2-base);
      }
    }
  }
}

.v-progress-linear__background {
  background-color: #fff !important;
  opacity: 1 !important;
}

.profile-padding {
  margin: 0 16px;
}

.progress-details-col {
  display: flex;
  justify-content: space-between;
  font-size: 0.78rem;
}
.viptier-details {
  border-radius: 10px;
}
.balance-details {
  height: 100%;
  font-style: normal;
  font-weight: 600;
  .MB-row {
    align-items: center;

    .MB-left-col {
      display: flex;
      flex-direction: column;
      gap: 8px 0px;

      .highlighted-span {
        font-size: 0.9rem;
      }
    }

    .MB-right-col {
      flex-direction: column;
      gap: 8px 0px;
    }
  }
  /* newmember */
  .level0 {
    //background: linear-gradient(98deg, #d0b6fe 0%, #cc9dda 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #5d0076 !important;
    background-color: #fddd04;
    color: black;
  }
  /* //bronze */
  .level1 {
    //background: linear-gradient(98deg, #f4cfb9 0%, #e1af92 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #915e51 !important;
    background-color: #fddd04;
    color: black;
  }
  /* //silver */
  .level2 {
    //background: linear-gradient(98deg, #c2c0da 0%, #9899c1 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #5a557f !important;
    background-color: #fddd04;
    color: black;
  }
  /* //ruby */
  .level3 {
    //background: linear-gradient(98deg, #f4c1c1 0%, #f97c7c 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #e10531 !important;
    background-color: #fddd04;
    color: black;
  }
  /* //gold */
  .level4 {
    //background: linear-gradient(98deg, #f1dc9c 0%, #ebc573 100%, #ebc573 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #915e51 !important;
    background-color: #fddd04;
    color: black;
  }
  /* //platinum */
  .level5 {
    //background: linear-gradient(98deg, #cedfff 0%, #89a8e4 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #6717cd !important;
    background-color: #fddd04;
    color: black;
  }

  .level6 {
    //background: linear-gradient(98deg, #cedfff 0%, #89a8e4 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #6717cd !important;
    background-color: #fddd04;
    color: black;
  }

  .level7 {
    //background: linear-gradient(98deg, #cedfff 0%, #89a8e4 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    //color: #6717cd !important;
    background-color: #fddd04;
    color: black;
  }

  &.bronze {
    background: linear-gradient(98deg, #f4cfb9 0%, #e1af92 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    color: #915e51 !important;
  }

  &.silver {
    background: linear-gradient(98deg, #b5b3cf 0%, #7377b5 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    color: #6164a7 !important;
  }
  &.gold {
    background: linear-gradient(98deg, #f1dc9c 0%, #ebc573 100%);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    color: #915e51 !important;
  }

  .MB-btm-row {
    align-items: center;
    font-size: 0.78rem;
    font-style: normal;
    font-weight: 600;
    color: #ffffff;
    text-transform: uppercase;
    border-top: 0.5px solid #ffffff;
    margin-top: 15px;
  }
}
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before,
.theme--light.v-list-item:hover::before {
  opacity: 0 !important;
}

.page-container {
  height: 86vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.v-list-item:hover::before {
  opacity: 0 !important;
}

.parentNav-list-group {
  width: 100%;
  border-bottom: 2px solid #c0bdbd;


  &.v-list-group--active {
    border-bottom: unset;
  }
  //parentNav expanded or active
  .v-list-group__header .v-item--active {
    border-bottom: 2px solid #dadada;
  }
  .parentNav-icon {
  }
  .v-list-group__header__prepend-icon {
    margin-right: 15px !important;
    margin-top: auto;
    margin-bottom: auto;
  }

  //parentNav group appendicon
  //.v-list-group--active>.v-list-group__header>.v-list-group__header__append-icon .v-icon{
  //  transform();
  //}
}
.no-border {
  border-bottom: unset;
}
.parentNav-title {
  font-size: 0.8rem !important;
}
.child-list-item {
  padding: 0 0 0 10px;
}
.childNav-list-group {
  width: 100%;
  .v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
    transform: unset !important;
  }

  .childNav-title {
    color: #9b9b9b !important;
    font-size: 0.8rem !important;
  }

  .v-item--active {
    border-bottom: unset !important;
  }
}

.mdi-chevron-right {
  transform: unset !important;
}

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 25px;
}
.v-application--is-ltr .v-divider--inset:not(.v-divider--vertical) {
  margin-left: 25px;
}
.member-balance {
  margin-left: 10px;
  margin-right: 10px;
  padding-top: 35px;
  margin-bottom: 20px;
}

.ma-list-nav {
  /* 1) Shorter rows (parents + children) */
  .v-list-group__header,
  .v-list-item {
    min-height: 44px !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  /* 2) 0.5px divider like Figma */
  .parentNav-list-group {
    border-bottom: 0.5px solid #d7d7d7 !important;
  }
  .parentNav-list-group.no-border {
    border-bottom: 0 !important;
  }
}

</style>
